import type { SlideProps } from "@/engine/app/offsite-config";

const STATS = [
  { value: "[X]", label: "Automatisierte Vorgänge" },
  { value: "[X]s", label: "Ø Verarbeitungszeit" },
  { value: "[X]%", label: "Fehlerquote" },
];

export function Slide15Zahlen(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 380,
          height: 380,
          top: "-100px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.28,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 280,
          height: 280,
          bottom: "-80px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.14,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ergebnisse</div>
        <h1 className="deck-title rise rise-2">
          Das haben wir <br />
          <span className="accent">erreicht</span>
        </h1>
      </header>

      <div className="deck-big">
        <div className="big-grid rise rise-4">
          {STATS.map((s, i) => (
            <div key={s.label} className="big-tile">
              <div className="tile-eyebrow">0{i + 1}</div>
              <div className="tile-value">{s.value}</div>
              <div className="tile-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
